"use client";
import { jsx as o } from "react/jsx-runtime";
import * as e from "react";
const t = /*#__PURE__*/ e.createContext("default"), m = (param)=>{
    let { isInverse: r, variant: a, children: n } = param;
    return /* @__PURE__ */ o(t.Provider, {
        value: a !== null && a !== void 0 ? a : r ? "inverse" : "default",
        children: n
    });
}, s = ()=>e.useContext(t), c = ()=>s() === "inverse";
export { m as ThemeVariant, c as useIsInverseVariant, s as useThemeVariant };
